export default {
  0: 'draft',
  2: 'open',
  4: 'cancelled',
  5: 'closed',
}
